import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: `/cards`,
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/views/PageNotFound.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Auth/LoginPage.vue"),
    meta: {
      permission: [],
    },
  },
  {
    path: "/",
    name: "LayoutPage",
    component: () => import("../views/LayoutPage.vue"),
    // redirect: "/warehouses",
    children: [
      {
        path: "cards",
        name: "cards",
        component: () => import("@/views/NewCardsView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "vip/cards",
        name: "vip-cards",
        component: () => import("@/views/vip/NewCardsView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "2fa/cards",
        name: "2fa-cards",
        component: () => import("@/views/2fa/NewCardsView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "2fa/cards/:name",
        name: "2fa-cards-name",
        component: () => import("@/views/2fa/CardsByStoreNameView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "alter-cards",
        name: "alter-cards",
        component: () => import("@/views/AlterCardsView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "cards/:id",
        name: "storeCards",
        component: () => import("@/views/CardsByStoreID.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "alter-cards/:id",
        name: "AlterStoreCards",
        component: () => import("@/views/AlterCardsByStoreID.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "vip/cards/:id",
        name: "vipStoreCards",
        component: () => import("@/views/vip/CardsByStoreID.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "stores",
        name: "stores",
        component: () => import("@/views/StoreView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "wallet",
        name: "wallet",
        component: () => import("@/views/WalletView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "vip/wallet",
        name: "vip-wallet",
        component: () => import("@/views/vip/WalletView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "alter-wallet",
        name: "alterWallet",
        component: () => import("@/views/AlterWalletView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "used-wallet",
        name: "used-wallet",
        component: () => import("@/views/UsedWalletView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "vip/used-wallet",
        name: "vip-used-wallet",
        component: () => import("@/views/vip/UsedWalletView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "used-alter-wallet",
        name: "used-alter-wallet",
        component: () => import("@/views/UsedAlterWalletView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "user-cards",
        name: "userCards",
        component: () => import("@/views/UserCards.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "smart-cards",
        name: "smartCards",
        component: () => import("@/views/SmartCards.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "user-wallet-cards",
        name: "userWalletCards",
        component: () => import("@/views/UserWalletView.vue"),
        meta: {
          permission: [],
        },
      },
      {
        path: "smart-wallet-cards",
        name: "smartWalletCards",
        component: () => import("@/views/SmartWalletView.vue"),
        meta: {
          permission: [],
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
